import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconMember = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <circle cx="9" cy="5.625" r="4.875" stroke="currentColor" strokeWidth="1.5" />
      <path d="M17 18H1C1 14.134 4.58172 11 9 11C13.4183 11 17 14.134 17 18Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default IconMember
